import { trapFocusOnModal } from '../util/modalFocusTrap';

export default {
  init() {
    const handleDevenirMembreModal = () => {
      const triggers = document.querySelectorAll('.js-rejoindre-modal');
      const modal = document.getElementById('devenir-membre-modal');
      if (triggers.length > 0 && modal) {
        triggers.forEach((trigger) => {
          trapFocusOnModal({ modal, trigger });
        });
      }
    };
    handleDevenirMembreModal();

    const handleDevenirSympathisantModal = () => {
      const triggers = document.querySelectorAll('.js-sympathisant-modal');
      const modal = document.getElementById('devenir-sympathisant-modal');
      if (triggers.length > 0 && modal) {
        triggers.forEach((trigger) => {
          trapFocusOnModal({ modal, trigger });
        });
      }
    };
    handleDevenirSympathisantModal();

    if (window.location.hash === '#membre') {
      const devenirMembreTrigger = document.querySelector('.js-rejoindre-modal');
      devenirMembreTrigger.click();
    }
    if (window.location.hash === '#sympathisant') {
      const sympathisantTrigger = document.querySelector('.js-sympathisant-modal');
      sympathisantTrigger.click();
    }
  },
};
